/**
 * @description
 *   1. Transforms the params object into an array like [[key, value], [key, value]]
 *   2. Filters the values that are empty
 *   3. Constructs back the object
 *
 * @param obj Object
 * @returns Object
 */
export default function removeEmptyValues(
  obj: Record<string, unknown>,
): Record<string, unknown> {
  return Object.entries(obj)
    .filter(([, value]) => value !== '')
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
}
